<div class="container">
    <div class="row product-row">
        <div class="col-lg col-12 product-col">
            <div class="professional-card mb-3 professional-hero">
                <div class="professional-info">
                    <div class="logo">
                        <img [src]="professional?.profession?.design?.logo?.url || image">
                    </div>
                    <div class="info">
                        <h4 class="title"><span class="h5">{{ translateHelper.localize(professional?.title) || professional?.name }}</span> - {{translateHelper.localize(professional.profession?.title) || professional.name}}</h4>
                        <div class="company-name" *ngIf="companyName">{{ companyName }}</div>
                        <div class="rating-row" *ngIf="professional.profession?.reviewCount">
                            <app-rating [value]="professional.profession?.averageRating"></app-rating>
                            <span class="rating-count">({{ professional.profession?.reviewCount }} {{"reviews"|translate}})</span>
                        </div>
                        <div class="location-row" *ngIf="locationLabel">
                            <mat-icon>location_on</mat-icon>
                            <span>{{ locationLabel }}</span>
                        </div>
                        <div class="location-row" *ngIf="professional.profession?.yearsOfExperience">
                            <mat-icon>work</mat-icon>
                            <span>{{ "years_of_experience_value" | translate: { years: professional.profession.yearsOfExperience } }}</span>
                        </div>
                        <p class="description m-0">{{translateHelper.localize(professional.profession?.description)}}</p>
                    </div>
                </div>
            </div>

            <div class="professional-card mb-3 professional-tabs">
                <mat-tab-group dynamicHeight>
                    <mat-tab [label]="'about'|translate">
                        <div class="tab-content">
                            <p class="bio" *ngIf="bio">{{ bio }}</p>
                            <p class="text-muted mb-0" *ngIf="!bio">{{ "no_bio_yet"|translate }}</p>

                            <div class="certifications" *ngIf="professional?.profession?.certifications?.length">
                                <h5><mat-icon>verified</mat-icon>{{"certifications"|translate}}</h5>
                                <ul class="certifications-list">
                                    <li *ngFor="let certification of professional.profession.certifications" class="certification-item">
                                        <div class="certification-name">{{translateHelper.localize(certification.name)}}</div>
                                        <div class="certification-dates">
                                            <span>{{"issued_date"|translate}}: {{certification.issuedDate | date}}</span>
                                            <span *ngIf="certification.expiryDate">&nbsp;&middot;&nbsp;{{"expires_at"|translate}}: {{certification.expiryDate | date}}</span>
                                        </div>
                                        <a *ngIf="certification.documentUrl" [href]="certification.documentUrl" target="_blank" rel="noopener" class="certification-document">
                                            {{"view_document"|translate}}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </mat-tab>

                    <mat-tab [label]="'services_and_pricing'|translate">
                        <div class="tab-content">
                            <div class="hourly-rate" *ngIf="professional.profession?.hourlyRate">
                                <mat-icon>payments</mat-icon>
                                <span>{{ "hourly_rate"|translate }}: {{ professional.profession.hourlyRate | currencyConvert: currencyRate.getBaseCurrency() }}{{ "per_hour_suffix"|translate }}</span>
                            </div>

                            <div class="services-grid" *ngIf="services.length">
                                <app-professional-service-card *ngFor="let service of services" [service]="service"
                                    [professionalSlug]="professional.profession?.seo?.slug || professional.profession?._id">
                                </app-professional-service-card>
                            </div>
                            <p class="text-muted mb-0" *ngIf="!services.length">{{ "no_services_yet"|translate }}</p>
                        </div>
                    </mat-tab>

                    <mat-tab [label]="'portfolio'|translate">
                        <div class="tab-content">
                            <div class="portfolio-grid" *ngIf="portfolioImages.length">
                                <a *ngFor="let image of portfolioImages" [href]="image.url" target="_blank" rel="noopener" class="portfolio-image">
                                    <img [src]="image.url">
                                </a>
                            </div>
                            <p class="text-muted mb-0" *ngIf="!portfolioImages.length">{{ "no_portfolio_images_yet"|translate }}</p>
                        </div>
                    </mat-tab>

                    <mat-tab [label]="'reviews'|translate" *ngIf="siteService.features?.reviews">
                        <div class="tab-content reviews-view">
                            <div class="reviews-view__header">
                                <button type="button" class="btn btn-secondary btn-sm" appClick (click)="openReviewDialog()">
                                    {{"write_review"|translate}}
                                </button>
                            </div>

                            <ol class="reviews-list" *ngIf="professional.profession?.reviews?.length; else noReviews">
                                <li *ngFor="let review of professional.profession.reviews" class="review-item">
                                    <div class="review-avatar">{{ review.name?.charAt(0) }}</div>
                                    <div class="review-body">
                                        <div class="review-author">{{ review.name }}</div>
                                        <app-rating [value]="review.rating"></app-rating>
                                        <div class="review-text" *ngIf="review.review">{{ review.review }}</div>
                                    </div>
                                </li>
                            </ol>
                            <ng-template #noReviews>
                                <p class="text-muted mb-0">{{"no_reviews_yet"|translate}}</p>
                            </ng-template>
                        </div>
                    </mat-tab>
                </mat-tab-group>
            </div>

            <div class="professional-card">
                <app-social-share-buttons></app-social-share-buttons>
            </div>
        </div>
    </div>
</div>
